var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-chart',{ref:("echart" + _vm.chartRefId),staticClass:"chart",style:(("height: " + _vm.getChartHeight + "px;")),attrs:{"autoresize":true,"option":_vm.getChartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }